// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  apiUrl: 'https://dev.omnia.ecs.net.br',
  omniaCoreApiUrl: 'https://omnia-core.dev.ecs.app.br',
  // webVisumTrafficUrl: 'https://traffic.dev.ecs.net.br',
  webVisumTrafficUrl: 'http://localhost:4201',
  socketCoreUrl: 'https://socket-core.dev.ecs.net.br',
  production: false,
  googleMapsKey: 'AIzaSyBmuWiHIuiMUuJu9NbsYrOgfhpTTVTuu_8',
  theme: 'ecs',
  growthbookHost: 'https://proxy-growthbook.ecs.net.br',
  growthbookKey: 'sdk-af8pTQiW4wpjT3O',
  recaptcha: {
    siteKey: '6LcYuM0rAAAAAIhw3_YHSPdxXGsJyqwP6aTdnIuZ',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
